/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.InfoButton = void 0;

var react_1 = __importDefault(require("react"));

var name = 'InfoButton';
exports.name = name;

var InfoButton = function InfoButton(_ref) {
  var Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "handleClick",
      value: function handleClick(e, onClick) {
        if (onClick) {
          onClick(e);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            _onClick = _this$props.onClick;
        return react_1.default.createElement(Text, {
          className: ['InfoButton__info-button', classes === null || classes === void 0 ? void 0 : classes.infoButton],
          onClick: function onClick(e) {
            return _this.handleClick(e, _onClick);
          },
          style: styles === null || styles === void 0 ? void 0 : styles.infoButton
        }, before, "i", after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.InfoButton = InfoButton;

var style = function style(theme) {
  var _a;

  return {
    infoButton: Object.assign({
      backgroundColor: '#aaa',
      borderRadius: 10,
      color: '#fff',
      cursor: 'pointer',
      fontSize: 12,
      fontStyle: 'italic',
      lineHeight: 1.5,
      marginLeft: 'auto',
      marginTop: 4,
      height: 17,
      textAlign: 'center',
      textIndent: -1,
      width: 17,
      '@mobile': {
        lineHeight: 0
      }
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.InfoButton) === null || _a === void 0 ? void 0 : _a.infoButton)
  };
};

exports.style = style;